<ng-container *ngIf="isReadonly; then readonlyContent; else editableContent"></ng-container>

<ng-template #readonlyContent>
  <div [class]="cssClass">
    <div class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ categoryName }}
        </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editableContent>
  <div [class]="cssClass">
    <div showButtonsOnHover class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <span *ngIf="!isEditing" (click)="enableEdit()" style="cursor: pointer">
          {{ viewName }}
        </span>
        <input
          *ngIf="isEditing"
          [(ngModel)]="editableText"
          [placeholder]="defaultName"
          (blur)="saveAndClose()"
          (keyup.enter)="saveAndClose()"
          (keyup.escape)="cancelEdit()"
          autofocus
          maxlength="100" />
      </div>
      <div style="gap: 8px" class="col-auto d-flex flex-row justify-content-center">
        <button
          *ngIf="showMoveIcon"
          class="btn btn-sm ca-btn ca-btn-neutral-command"
          (click)="onStartMove($event)"
          [ngbTooltip]="
            node === movingNode
              ? ('Query::CancelMove' | abpLocalization)
              : ('Query::Move' | abpLocalization)
          "
          placement="bottom">
          <i
            class="far"
            [ngClass]="{
              'fa-arrows': node !== movingNode,
              'fa-times': node === movingNode
            }"></i>
        </button>

        <button
          *ngIf="movingNode && canMoveHere"
          class="btn btn-sm ca-btn ca-btn-neutral-command move-here-btn"
          (click)="onMoveHereClick($event)">
          {{ 'Query::Move' | abpLocalization }}
        </button>
        <ca-query-builder-node-duplicate-button
          (buttonClick)="onClickDuplicate($event)"></ca-query-builder-node-duplicate-button>
        <ca-query-builder-node-remove-button
          (buttonClick)="removeNode($event)"></ca-query-builder-node-remove-button>
        <button
          class="btn btn-sm ca-btn ca-btn-neutral-command"
          [matMenuTriggerFor]="root"
          (menuOpened)="onMenuOpened($event)"
          (menuClosed)="onMenuClosed($event)"
          ngbTooltip="{{ '::AddNewNode' | abpLocalization }}"
          placement="bottom">
          <i class="fad fa-layer-plus"></i>
        </button>

        <mat-menu #root="matMenu">
          <ng-container *ngFor="let category of categories">
            <button
              mat-menu-item
              [matMenuTriggerFor]="sub_menu"
              class="tree-node-menu-button mt-1 mb-1">
              <div class="query-btn" [ngClass]="'query left-bordered ps-2 ' + category.cssClass">
                {{ 'Conversation::' + category.title | abpLocalization }}
              </div>
            </button>
            <mat-menu #sub_menu="matMenu">
              <ng-container *ngFor="let categoryItem of category.items">
                <button
                  class="tree-node-menu-button mt-1 mb-1"
                  *ngIf="isCategoryItemVisible(categoryItem)"
                  [disabled]="isCategoryItemDisabled(categoryItem)"
                  mat-menu-item
                  (click)="onAddNodeClick(category, categoryItem)">
                  <div
                    class="query-btn"
                    [ngClass]="'query left-bordered ps-2 ' + category.cssClass">
                    {{ 'Conversation::' + categoryItem.title | abpLocalization }}
                  </div>
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </mat-menu>
      </div>
    </div>
  </div>
</ng-template>
